import styled from 'styled-components'

export const Button = styled.label`
  height: 4rem;
  width: 20rem;

  margin-top: 4rem;
  background-color: #f0951f;
`
